"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const WizardStepHeading = ({ heading, children, title }) => {
    const childArray = react_1.default.Children.toArray(children);
    return (react_1.default.createElement("div", { className: 'wizard-step-heading' },
        react_1.default.createElement("h6", null, heading),
        childArray.map((child, index) => (react_1.default.createElement("p", { key: index }, child))),
        title && react_1.default.createElement("h1", null, title)));
};
exports.default = WizardStepHeading;
